import { css } from "@emotion/react";

export const input = css`
  margin: 15px 0;
`;

export const inputField = css`
  border-radius: 5px;
`;
